import Image from "next/image";
import Link from "next/link";
import { mwImage, stripImageSizeSuffix } from "../../../lib/common";
import { TwitterIconV2, LinkedInIconV2, FacebookIconV2 } from "../icons";

type Props = { post: any };

/**
 * “Written By” author block used under the main article body.
 */
export default function BlogAuthorHero({ post }: Props) {
  const author = post?.author?.node;
  if (!author) return null;

  const authorSlug = author.slug || author.username || "";
  const avatarUrl = author?.avatar?.url
    ? mwImage(stripImageSizeSuffix(author.avatar.url))
    : null;

  return (
    <div className="blog-written-by">
      <div className="blog-written-by-badge section-tag testimonial">Written By</div>
      <div className="blog-written-by-avatar">
        <div className="blog-written-by-avatar-hex">
          {avatarUrl ? (
            <Image
              src={avatarUrl}
              alt={author?.name}
              width={84}
              height={84}
              loading="lazy"
              unoptimized
            />
          ) : null}
        </div>
      </div>
      <div className="blog-written-by-content">
        <div className="blog-written-by-header">
          <h3 className="title">
            {authorSlug ? (
              <Link href={`/blog/authors/${authorSlug}/`} prefetch={false}>
                {author.name}
              </Link>
            ) : (
              author.name
            )}
          </h3>
          <div className="author-social">
            {author?.seo?.social?.twitter && (
              <Link
                href={`https://x.com/${author?.seo?.social?.twitter}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Author on X"
              >
                <TwitterIconV2 />
              </Link>
            )}
            {author?.seo?.social?.facebook && (
              <Link
                href={author?.seo?.social?.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Author on Facebook"
              >
                <FacebookIconV2 />
              </Link>
            )}
            {author?.seo?.social?.linkedIn && (
              <Link
                href={author?.seo?.social?.linkedIn}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Author on LinkedIn"
              >
                <LinkedInIconV2 />
              </Link>
            )}
          </div>
        </div>
        {author.description != null ? (
          <p className="description">&quot;{author.description}&quot;</p>
        ) : null}
      </div>
    </div>
  );
}
